import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useAuthStore } from '@/app/store/authStore';
import NotificationsList from 'ah-notifications/src/components/notifications/NotificationsList.vue';
import LastLoginInfo from '@/app/components/session/LastLoginInfo.vue';
import NotificationsIcon from '@/app/icons/svgs/UpdatesIcon.vue';
import XHedgeNotificationsModal from '../nav/XHedgeNotificationsModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsDashboardWidget',
  setup(__props) {

const user = computed(() => useAuthStore().loggedInIdentity);

const notificationList = ref<InstanceType<typeof NotificationsList> | null>(null);

const greetingLabel = computed(() => {
  const now = new Date();

  if (now.getHours() > 5 && now.getHours() <= 12) {
    return 'Morning';
  } else if (now.getHours() > 12 && now.getHours() <= 18) {
    return 'Afternoon';
  } else {
    return 'Night';
  }
});

return { __sfc: true,user, notificationList, greetingLabel, NotificationsList, LastLoginInfo, NotificationsIcon, XHedgeNotificationsModal }
}

})